module.exports = __webpack_public_path__ + "img/image_22.1709b8b5.png";